document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-tps-menu-toggle]');
  var mobileMenu = document.querySelector('[data-tps-menu-mobile]');

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
});
